import { LOGIN } from '../actions/login/loginAction';
import { LOGOUT } from '../actions/login/logoutAction';
const storageKey = 'user';

const authReducer = (
  state = {
    isAuthUser: !!localStorage.getItem(storageKey),
    user: JSON.parse(localStorage.getItem(storageKey)) || {},
    isLoading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case LOGIN:
      localStorage.setItem(storageKey, JSON.stringify(action.payload.user));
      return { ...state, isAuthUser: true, user: action.payload.user };
    case LOGOUT:
      localStorage.removeItem(storageKey);
      return { ...state, isAuthUser: false, user: {} };
    default:
      return state;
  }
};

export default authReducer;
